export { default } from './cookie-consent';
export { default as styles } from './cookie-consent.styles';
